import { render } from "./Wizard.vue?vue&type=template&id=0be1a7fe&lang=true"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"
script.render = render

export default script